// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-form-dialog[data-v-11ea651f] .el-form.form-create .el-form-item{margin-bottom:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
